import { Outlet } from 'react-router-dom'

export default function QuizOnboardingOutlet() {
  return <Outlet />
}
